import './pop-upDelete.scss'
import React from 'react'

const ImagePreviev = ({ imgUrl, imagesSHow, onDidDismiss }) => {
  
  return (
    <>
      {imagesSHow && (
        <div className="editPopUpDelete">
          <div
            className="pop-upDelete_wrapper"
            onClick={(e) => {
              if (e.currentTarget === e.target) {
                onDidDismiss(false)
              }
            }}
          >
            <div className="pop-upDelete">
              <div
                onClick={(e) => {
                  if (e.currentTarget === e.target) {
                    onDidDismiss(false)
                  }
                }}
                style={{
                  background: '#000',
                  borderRadius: '50%',
                  position: 'absolute',
                  right: '-12px',
                  top: ' -8px',
                  height: '27px',
                  width: '27px',
                  textAlign: 'center',
                  margin: 0,
                  padding: '2px',
                  fontWeight: 900,
                  boxShadow:
                    ' rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
                }}
              >
                x
              </div>
              <img src={imgUrl} height={500} alt="preview" />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ImagePreviev
